import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IRevenueCode extends IModelBase {
  Value: string
  Description: string
}

@Injectable()
export class RevenueCodeODataService extends ODataService<IRevenueCode> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RefRevenueCodes'
  }
}
